import { computed, inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { printersActions } from '../actions/printers.actions';
import { selectLabelDimensions, selectLoaded, selectLoading, selectPrinters, selectStatuses } from '../selectors/printers.selector';

@Service()
export class PrintersFacade {
    private readonly store = inject(Store);

    readonly printers = this.store.selectSignal(selectPrinters);
    readonly statuses = this.store.selectSignal(selectStatuses);
    readonly labelDimensions = this.store.selectSignal(selectLabelDimensions);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly loaded = this.store.selectSignal(selectLoaded);

    /** Print targets. Every print picker offers these and defaults its selection from them. */
    readonly enabledPrinters = computed(() => this.printers().filter((printer) => printer.enabled));

    // `withStatus` triggers the live status fan-out; `background` skips the full-page loader.
    getPrinters(withStatus = false, background = false): void {
        this.store.dispatch(printersActions.getPrinters({ withStatus, background }));
    }

    getLabelDimensions(): void {
        this.store.dispatch(printersActions.getLabelDimensions());
    }

    clear(): void {
        this.store.dispatch(printersActions.clear());
    }
}
